class CheckoutErrorOfflineModal extends Modal {
    constructor() {
        super();
        this._stack = '';
        this._message = '';
        this._html = '';
    }

    get message() {
        return this._message;
    }

    set message(value) {
        this._message = value;
        this.querySelector('[data-message]').textContent = value;
    }

    get html() {
        return this._html;
    }

    set html(value) {
        this._html = value;
        this.querySelector('[data-html]').innerHTML = value;
    }

    get stack() {
        return this._details;
    }

    set stack(value) {
        this._stack = value;
        this.querySelector('[data-stack]').textContent = value;
    }

    open(evt) {
        this.querySelector('.modal__window').style.maxWidth = 'unset';
        this.querySelector('[data-time]').textContent = new Date().toUTCString();
        this.querySelector(`[data-req-trace]`).innerHTML = this.prettyJson(JSON.parse(localStorage.getItem('req_trace') || '[]'));
        document.dispatchEvent(new CustomEvent('timeout:pause', { bubbles: true }));
        setTimeout(() => { document.dispatchEvent(new CustomEvent('loading-bar:hide', { bubbles: true })); }, 2000);
        super.open(evt);
    }

    close(evt) {
        if (evt == undefined) return;
        document.dispatchEvent(new CustomEvent('loading-bar:hide', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('timeout:resume', { bubbles: true }));
        super.close(evt);
    }

    prettyJson(input) {

        var jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/mg;

        var replacer = function (match, pIndent, pKey, pVal, pEnd) {
            var key = '<span class="json-key" style="color: brown">',
                val = '<span class="json-value" style="color: navy">',
                str = '<span class="json-string" style="color: olive">',
                r = pIndent || '';
            if (pKey)
                r = r + key + pKey.replace(/[": ]/g, '') + '</span>: ';
            if (pVal)
                r = r + (pVal[0] == '"' ? str : val) + pVal + '</span>';
            return r + (pEnd || '');
        };

        return JSON.stringify(input, null, 3)
            .replace(/&/g, '&amp;').replace(/\\"/g, '&quot;')
            .replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(jsonLine, replacer);
    }
}

customElements.define('checkout-error-offline', CheckoutErrorOfflineModal);